import React from 'react';
import { useSelector } from 'react-redux';
import getDeliveryDetails from 'store/product/selector/getDeliveryDetails';
import styles from './OPPlusFreeShippingV2.module.scss';

const OPPlusFreeShippingV2 = () => {
  const deliveryDetails = useSelector(getDeliveryDetails);
  if (!deliveryDetails) {
    return null;
  }

  if ((deliveryDetails as any).opplus.isOpPlusSubscribed) {
    return null;
  }
  return (
    <div
      className={styles.OPPlusFreeShipping}
      dangerouslySetInnerHTML={{ __html: (deliveryDetails as any).opplus.opPlusProductPageDescription }}
    />
  );
};

export default OPPlusFreeShippingV2;
